import { IActiveTermsCulture } from "./active-terms-culture";

export interface IActiveTerms {
  id: number;
  providerId: number;
  availableCultures: IActiveTermsCulture[];
  isActiveFromDateDays: number;
  isActiveToDateDays: number;
  deadLineDateDays: number;
  termsType: string;
  isRejected: boolean;
}
